import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Mon parcours`}</h2>
    <p><strong parentName="p">{`JUIN 2016`}</strong><br parentName="p"></br>{`
`}{`Brevet | Collège Maurice Utrillo Brevet des collèges mention bien.
Premières expériences en remplaçant le système d'exploitation de mon téléphone par feu CyanogenMod, et de mon ordinateur par Debian (Linux).`}</p>
    <p><strong parentName="p">{`2016 – 2017`}</strong><br parentName="p"></br>{`
`}{`2nde Section Européenne Anglais | Lycée Camille Saint-Saëns
Option d’exploration ICN (Informatique et Création du Numérique), création et hébergement d’un site internet. Introduction au domaine de la programation, premiers pas en HTML et CSS.`}</p>
    <p><strong parentName="p">{`2018 – 2019`}</strong><br parentName="p"></br>{`
`}{`Terminale S Section Européenne Anglais | Lycée Camille Saint-Saëns
Spécialité ISN (Informatique et Sciences du Numérique)
Obtention d’un bac S mention assez bien.
Apprentissage de Python, intéressement croissant pour les algorithmes complexes.`}</p>
    <p><strong parentName="p">{`2019 - 2021`}</strong><br parentName="p"></br>{`
`}{`Dut Informatique en apprentissage | Sorbonne Paris Nord`}<br parentName="p"></br>{`
`}{`Apprenti chez Allianz en tant que développeur VBA. Lien entre l'informatique et les services comptables.
Autoformation en VBA et SAS.`}<br parentName="p"></br>{`
`}{`Cours de programmation Python avancé, et découverte de nouveaux langages tels que Java, SQL, ou encore Scala.`}</p>
    <p><strong parentName="p">{`2021 - 2022`}</strong><br parentName="p"></br>{`
`}{`Ingénierie de la 3D et des Jeux Vidéo | ESGI`}<br parentName="p"></br>{`
`}{`Apprenti chez H'ability, une startup visant à rendre la rééducation des personnes ayant eu un AVC plus ludique.
Développement de jeux en réalité virtuelle avec Unity, sur les casques Meta Quest 2 et HTC Vive Focus 3.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      